import React, { useEffect, useState, memo } from "react";
import ReactPlayer from "react-player";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { blueGradient, DefaultText, shadow } from "theme/GlobalElements";
import { zIndexes } from "theme/Theme";
import { getVideoData, selectVideoPlayerData } from "./videoPlayerSlice";

const VideoPlayer = () => {
  const dispatch = useDispatch();

  const video = useSelector(selectVideoPlayerData);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [hasError, setHasError] = useState(false);
  const hidePlayer = () => {
    setHasError(true);
  };

  useEffect(() => {
    !video && dispatch(getVideoData());
  }, []);

  return (
    <VideoPlayerContainer>
      {!hasError && video && (
        <>
          <DefaultText
            color="black"
            fontSize={isMobile ? 16 : 22}
            style={{ marginBottom: isMobile ? "10px" : "30px" }}
            fontWeight="500"
          >
            {video?.title}
          </DefaultText>

          <PlayerContainer>
            <PlayerWrapper>
              <ReactPlayer
                className="react-player"
                loop={true}
                // playing={inView}
                playing={false}
                volume={0.2}
                width={"100%"}
                height={"100%"}
                url={video?.link}
                onError={hidePlayer}
              />
            </PlayerWrapper>
          </PlayerContainer>
        </>
      )}
    </VideoPlayerContainer>
  );
};

const VideoPlayerContainer = styled.div`
  margin: 10px 0;
  padding: 15px 0;
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* ${blueGradient};
  ${shadow}; */

  @media only screen and (${device.tablet}) {
    margin: 15px 0;
    padding: 20px 0;
  }

  @media only screen and (${device.laptop}) {
    margin: 20px 0;
    padding: 30px 0;
  }
`;

const PlayerContainer = styled.div`
  width: 90%;
  height: auto;
  ${shadow};

  @media only screen and (${device.laptop}) {
    width: 70%;
  }

  @media only screen and (${device.desktop}) {
    width: 60%;
  }
`;

const PlayerWrapper = styled.div`
  width: 100%;
  padding-top: 56.25%;
  position: relative;
  .react-player {
    top: 0;
    left: 0;
    position: absolute;
    z-index: ${zIndexes.defaultAbsolute};
  }
`;

export default memo(VideoPlayer);
